var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from "aurelia-framework";
import { BaseQuickPlay } from "../../../base-quick-play";
import { QuickPlayLottery } from "./quick-play-lottery";
import { BrandingBase } from "../../../../../../views/app/admin/branding/branding-base";
import { TokenClient } from "../../../../../../services/authentication/token-client.service";
import { LotteryKeyHelper } from "../../../../../../services/modules/brand-client.service";
var QuickPlay = /** @class */ (function (_super) {
    __extends(QuickPlay, _super);
    function QuickPlay(quickPlayLottery, tokenClient) {
        var _this = _super.call(this) || this;
        _this.quickPlayLottery = quickPlayLottery;
        _this.tokenClient = tokenClient;
        return _this;
    }
    QuickPlay.prototype.showQuickPlay = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Text
                "quick-play",
                "quick-play-desc",
                "quick-play-choose-tickets-lines-button-add",
                "quick-play-choose-tickets-draws-label",
                "quick-play-choose-tickets-draws-info",
                "quick-play-choose-tickets-draw",
                "quick-play-choose-tickets-draws",
                "quick-play-choose-tickets-line",
                "quick-play-choose-tickets-lines",
                "quick-play-choose-tickets-total",
                "quick-play-choose-tickets-add-to-cart",
                "quick-play-choose-tickets-get-tickets",
                "quick-play-choose-tickets-login-message",
                "no-draws-set-up",
                "select-draw-number",
                "prices-not-set-for-your-currency",
                "no-tickets-to-purchase",
                "updated-cart",
                "no-tickets-to-add-to-cart",
                "tickets-added-to-cart",
                //Colors
                "quick-play-background",
                "quick-play-title-foreground",
                "quick-play-desc-foreground",
                "quick-play-lotteries-jackpot-foreground",
                "quick-play-choose-tickets-header-title-foreground",
                "quick-play-choose-tickets-header-date-foreground",
                "quick-play-choose-tickets-header-prize-foreground",
                "quick-play-choose-tickets-line-background",
                "quick-play-choose-tickets-line-num-background",
                "quick-play-choose-tickets-line-num-foreground",
                "quick-play-choose-tickets-line-num-bonus-background",
                "quick-play-choose-tickets-line-num-bonus-foreground",
                "quick-play-choose-tickets-add-line-background",
                "quick-play-choose-tickets-add-line-background-hover",
                "quick-play-choose-tickets-add-line-foreground",
                "quick-play-choose-tickets-add-line-foreground-hover",
                "quick-play-choose-tickets-draw-background",
                "quick-play-choose-tickets-draw-border",
                "quick-play-choose-tickets-draw-foreground",
                "quick-play-choose-tickets-draw-selected-background",
                "quick-play-choose-tickets-draw-selected-border",
                "quick-play-choose-tickets-draw-selected-foreground",
                "quick-play-choose-tickets-line-draw-foreground",
                "quick-play-choose-tickets-total-label-foreground",
                "quick-play-choose-tickets-total-value-foreground",
                "quick-play-choose-tickets-button-cart-background",
                "quick-play-choose-tickets-button-cart-hover-background",
                "quick-play-choose-tickets-button-cart-foreground",
                "quick-play-choose-tickets-button-cart-hover-foreground",
                "quick-play-choose-tickets-button-get-background",
                "quick-play-choose-tickets-button-get-hover-background",
                "quick-play-choose-tickets-button-get-foreground",
                "quick-play-choose-tickets-button-get-hover-foreground",
                "quick-play-choose-tickets-login-message-background",
                "quick-play-choose-tickets-login-message-foreground",
            ]
        }, window.parent.location.origin);
    };
    QuickPlay.prototype.getLotteryKey = function (name) {
        var key = name ? LotteryKeyHelper.getKey(name) : '';
        return key;
    };
    QuickPlay = __decorate([
        autoinject,
        __metadata("design:paramtypes", [QuickPlayLottery, TokenClient])
    ], QuickPlay);
    return QuickPlay;
}(BaseQuickPlay));
export { QuickPlay };
